import {useTranslation} from 'react-i18next';
import {ProgramInstructionsList} from '../../common/ProgramInstructionsList';
import { getMultileExerciseStatus } from '../../../services/user';
import { constants, Tag } from '../../../assets/constants/constants';
import { useEffect, useState } from 'react';
import FinishProgram from './FinishProgram';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'alm-react-components';
import { ProgramOverViewContent } from './ProgramOverViewContent';
import PageLoader from '../../common/loader/PageLoader';

type ProgramInstructionsProps = {
  courseDetails: any;
  pId: string;
  userEnrolmentDate: string;
  isFundamentalProgram: boolean;
  programDetailObject: any;
  isAllProgramCompleted?: boolean;
  programStart: any;
  programFinishLottieLocation: string;
  programBadgeLottieLocation: string;
  learningProgramStatus: any;
  currentQuarter: any;
  hidePageLoader:any;
  badgeDetailData:any
  watchRecordingId:any
};
export const ProgramInstructions: React.FC<ProgramInstructionsProps> = ({
  courseDetails,
  pId,
  userEnrolmentDate,
  isFundamentalProgram,
  programDetailObject,
  hidePageLoader,
  programStart,
  programFinishLottieLocation,
  programBadgeLottieLocation,
  learningProgramStatus,
  currentQuarter,
  badgeDetailData,
  watchRecordingId
}) => {
  const { t } = useTranslation();
  const [programWeekDetail, setProgramWeekDetail] = useState<[]>([]);
  const [introTab, setIntroTab] = useState("lessons");
  const [loading, setLoading] = useState(true);
  
  const filterTags= (tags: string) =>{
    if(!tags) return false;
    if( tags.includes(Tag.exercise)){
      return true
    }else if(tags.includes(Tag.liveclass)){
      return true
    }else{
      return false
    }
  };

  useEffect(() => {
    const updateLessionStatus = async () => {
      // Get the courseIds of the exercise courses from the courseDetails array
      // Filter the courseDetails array to get the week and lession arrays for the exercise courses
      // Flatten the lession arrays to get the courseIds
       const exersizeCourse = courseDetails
        ?.filter((res: any) => res?.visible )
        .map((week: any) => {
          return week?.courseArray?.filter((lession: any) => filterTags(lession?.tags)).flat((val: any) =>val.id);
        }).flat().map((lession: any) => lession.id);
      // Update the state of the course in the courseDetails array accordingly
      // The courseDetails array is used to display the program in the UI.
      // If the courseId exists in the res.data, it means the user has completed the course.
      // If the courseId does not exist, it means the user has not completed the course.
      // The state of the course is updated based on the isCourseCompleted flag in the res.data.
      // The state is set to COMPLETED if the isCourseCompleted flag is 1, otherwise it is set to the state of the course in the courseDetails array.
      // The updated courseDetails array is then set to the programWeekDetail state variable.
     
      getMultileExerciseStatus(exersizeCourse).then((res: any) => {
        
        if (res.data.length) {
           courseDetails?.map((week: any,weekIndex:number) => {
                 week?.courseArray?.map((lession: any,lessionIndex:number) => {
                  const filter =  res.data.filter((val:any) => val.courseId == lession.id)[0];
                  if (filter !== undefined) { 
                    courseDetails[weekIndex].courseArray[lessionIndex].state=filter?.isCourseCompleted === 1 ? constants.COMPLETED : lession.state
                  }  
              });
            });
          setProgramWeekDetail(courseDetails.filter((res:any)=>res?.visible));
        } else {
          setProgramWeekDetail(courseDetails.filter((res:any)=>res?.visible));
        }
        setLoading(false);
      });
    };
    updateLessionStatus();
  }, [courseDetails, pId]);

  const handleTab = (tab: string) => {
    setIntroTab(tab);
  };

  if (loading) {
    return (
      <PageLoader/>
    );
  }

  return (
    <section className="mx-auto mt-16 xl:px-32 lg:px-8 md:px-8 px-5">
      <Tabs
        defaultValue="lessons"
        className="w-full bg-transparent break-words"
      >
        <TabsList className="w-full bg-transparent items-start justify-start border-b rounded-none h-auto p-0 gap-x-8 tracking-widest">
          <TabsTrigger
            onClick={() => handleTab("lessons")}
            value="lessons"
            className={`px-0 pb-4 pt-5 font-helveticaMedium text-lg h-auto rounded-none mx:13px ml-0 md:mx-[0] md:ml-[0px]  ${
              introTab === "lessons"
                ? "active:border-primary  border-b-[6px] dark:border-primary dark:text-white active:dark:border-primary"
                : ""
            }`}
          >
            <span dangerouslySetInnerHTML={{ __html: t("Common.lessons") }} />
          </TabsTrigger>
          <TabsTrigger
            onClick={() => handleTab("overview")}
            value="overview"
            className={`px-0 pb-4 pt-5 font-helveticaMedium text-lg h-auto rounded-none mx:13px ml-0 md:mx-[0] md:ml-[0px]  ${
              introTab === "overview"
                ? "active:border-primary  border-b-[6px] dark:border-primary dark:text-white active:dark:border-primary"
                : ""
            }`}
          >
            <span dangerouslySetInnerHTML={{ __html: t("Common.overview") }} />
          </TabsTrigger>
        </TabsList>
        <TabsContent value="lessons" className="w-full py-5 break-words">
          <h3 className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light mb-10">
            <span dangerouslySetInnerHTML={{ __html: isFundamentalProgram ? t('Program.programInstructions'):  t('Program.classInstructions')}} /> 
          </h3>
          <ProgramInstructionsList
            courseDetails={programWeekDetail}
            userEnrolmentDate={userEnrolmentDate}
            isFundamentalProgram={isFundamentalProgram}
            pId={pId}
            currentQuarter={currentQuarter}
            programStart={programStart}
            programDetailObject={programDetailObject}
            hidePageLoader={hidePageLoader}
            watchRecordingId={watchRecordingId}
          />
          <div className="flex justify-end pb-10">
            {currentQuarter && programWeekDetail.length > 0 && 
              <FinishProgram
                programDetailObject={programDetailObject}
                programFinishLottieLocation={programFinishLottieLocation}
                programBadgeLottieLocation={programBadgeLottieLocation}
                programStatus={programDetailObject.programStatus}
                learningProgramStatus={learningProgramStatus}
                courseDetails={programWeekDetail}
                isFundamentalProgram={isFundamentalProgram}
                currentQuarter={currentQuarter}
                pId={pId}
                badgeDetailData={badgeDetailData}
              />
            }
          </div>
        </TabsContent>
        <TabsContent value="overview" className="w-full py-5 break-words">
          <ProgramOverViewContent programDetailObject={programDetailObject} />
        </TabsContent>
      </Tabs>
    </section>
  );
};
